import ProfileGift from '@/assets/img/profile_ic_gift@2x.png'
import ProfileTrace from '@/assets/img/profile_ic_trace@2x.png'
import ProfileThanks from '@/assets/img/profile_list_ic_thanks@2x.png'
import ProfileSubscribe from '@/assets/img/profile_ic_subscription@2x.png'
import ProfilePriNote from '@/assets/img/profile_ic_list@2x.png'
import ProfileDemand from '@/assets/img/profile_ic_demand@2x.png'
import BrandSignature from '@/assets/img/brand/icon-profile-sign.png'
import BrandGiftManager from '@/assets/img/brand/icon-profile-brandgift.png'
import ProfileLoveboxAskFor from '@/assets/icon/profile/profile_list_ic_askfor@2x.png'
import userWish from '@/assets/icon/profile/profile_data_ic_love@2x.png'
import ProfileRequest from '@/assets/img/profile_list_ic_suoqu@2x.png'
import ProfileAskfor from '@/assets/img/profile_ic_askfor@2x.png'
import ProfileMoment from '@/assets/img/profile_list_ic_talk@2x.png'
// import ProfileInvite from '@/assets/img/profile_data_ic_invite_friends.png'
import ProfileRadish from '@/assets/icon/profile/profile_radish.png'
import ProfileSponsor from '@/assets/icon/profile/profile_sponsor.png'
import ProfileExpress from '@/assets/img/profile_ic_express.png'
import ProfileCoupon from '@/assets/icon/profile/profile_coupon.png'

// sidebar icon
import iconSidebar01 from '@/assets/icon/filter/sidebar_ic_01@2x.png'
import iconSidebar02 from '@/assets/icon/filter/sidebar_ic_03@2x.png'
import iconSidebar03 from '@/assets/icon/filter/sidebar_ic_02@2x.png'
import iconSidebar04 from '@/assets/icon/filter/sidebar_ic_04@2x.png'
import iconSidebar05 from '@/assets/icon/filter/sidebar_ic_05@2x.png'
import iconSidebar06 from '@/assets/icon/filter/sidebar_ic_06@2x.png'
import iconSidebar07 from '@/assets/icon/filter/sidebar_ic_07@2x.png'
import iconSidebar08 from '@/assets/icon/filter/sidebar_ic_08@2x.png'
import iconSidebar09 from '@/assets/icon/filter/sidebar_ic_09@2x.png'
import iconSidebar10 from '@/assets/icon/filter/sidebar_ic_10@2x.png'
import iconSidebar11 from '@/assets/icon/filter/sidebar_ic_11@2x.png'
import iconSidebar12 from '@/assets/icon/filter/sidebar_ic_12@2x.png'
import iconSidebar13 from '@/assets/icon/filter/sidebar_ic_13@2x.png'
import iconSidebar14 from '@/assets/icon/filter/sidebar_ic_14@2x.png'
import iconSidebar15 from '@/assets/icon/filter/sidebar_ic_15@2x.png'
import iconSidebar16 from '@/assets/icon/filter/sidebar_ic_16@2x.png'
import iconSidebar17 from '@/assets/icon/filter/sidebar_ic_17@2x.png'
import iconSidebar18 from '@/assets/icon/filter/sidebar_ic_18@2x.png'
import iconSidebar19 from '@/assets/icon/filter/sidebar_ic_19@2x.png'
import iconSidebar20 from '@/assets/icon/filter/sidebar_ic_20@2x.png'
import iconSidebar21 from '@/assets/icon/filter/sidebar_ic_21@2x.png'

export const googleClientID =
  '102978352106-mipjlpsqq3rvd4068c8ncpbfc60kj0tg.apps.googleusercontent.com'

export const ANNUAL_REPORT_YEAR = 2025
export const ANNUAL_REPORT_SHOW_START_TIME = '2026/02/13'
export const ANNUAL_REPORT_SHOW_END_TIME = '2026/03/13'

export const otherUserMenuList = [
  {
    text: '送禮物管理',
    textOther: '送禮物',
    link: '/user/:hash/gifts',
    icon: ProfileGift
  },
  {
    text: '我的索取',
    textOther: '索取',
    link: '/user/:hash/deals',
    icon: ProfileAskfor
  },
  {
    text: '需求管理',
    textOther: '需求',
    link: '/user/:hash/needs',
    icon: ProfileDemand
  },
  {
    text: '感謝的話',
    textOther: '感謝',
    link: '/user/:hash/thanksword',
    icon: ProfileThanks
  },
  {
    text: '我的說說',
    textOther: '說說',
    link: '/user/:hash/moments',
    icon: ProfileMoment
  },
  {
    text: '心願認養',
    textOther: '心願認養',
    link: '/user/:hash/wishes',
    icon: userWish
  }
]

export const myUserMenuList = [
  {
    text: '送禮物管理',
    textOther: '送禮物',
    link: '/user/:hash/gifts',
    icon: ProfileGift
  },
  {
    text: '品牌好物管理',
    textOther: '',
    link: '/user/:hash/brandGifts',
    icon: BrandGiftManager,
    // 僅專業版會員（減碳帳戶）顯示
    show: (vm) => vm.user.isRecycleId
  },
  {
    text: '需求管理',
    textOther: '需求',
    link: '/user/:hash/needs',
    icon: ProfileDemand
  },
  {
    text: '品牌簽名檔',
    textOther: '',
    link: '/user/:hash/brandSignature',
    icon: BrandSignature,
    // 減碳專戶才有該權限
    show: (vm) => {
      return vm.user.showRecycleIdMenu
    }
  },
  {
    text: '我的蘿蔔點數',
    textOther: '',
    link: '/user/:hash/wallet',
    icon: ProfileRadish
  },
  {
    text: '感謝的話',
    textOther: '感謝',
    link: '/user/:hash/thanksword',
    icon: ProfileThanks
  },
  {
    text: '分享通',
    textOther: '',
    link: '/express/orders',
    icon: ProfileExpress
  },
  {
    text: '心願認養',
    textOther: '心願認養',
    link: '/user/:hash/wishes',
    icon: userWish
  },
  // {
  //   text: '邀請新會員',
  //   textOther: '',
  //   link: '/invite',
  //   icon: ProfileInvite
  // },
  {
    text: '我的說說',
    textOther: '說說',
    link: '/user/:hash/moments',
    icon: ProfileMoment
  },
  {
    text: '索取管理',
    textOther: '索取管理',
    link: '/user/:hash/deals',
    icon: ProfileRequest
  },
  {
    text: '我的追蹤',
    textOther: '追蹤',
    link: '/user/:hash/traces',
    icon: ProfileTrace
  },
  {
    text: '我的關鍵字訂閱',
    textOther: '關鍵字訂閱',
    link: '/user/:hash/subscribe',
    icon: ProfileSubscribe
  },
  {
    text: '我的好壞名單',
    textOther: '好壞名單',
    link: '/user/:hash/privateNote',
    icon: ProfilePriNote
  },
  {
    text: '我索取的GC代贈',
    textOther: '索取的GC代贈',
    link: '/user/:hash/shop',
    icon: ProfileLoveboxAskFor
  },
  {
    text: '我的贊助',
    link: '/user/:hash/sponsor',
    icon: ProfileSponsor
  },
  {
    text: '抵用券',
    link: '/wallet/coupons',
    icon: ProfileCoupon
  }
]

export const userGiftsNavList = [
  {
    text: '進行中',
    url: '/gifts?page=1',
    status: 'ongoing',
    key: 'ongoing'
  },
  {
    text: '未開始',
    url: '/gifts?page=1',
    status: 'pending',
    key: 'pending'
  },
  {
    text: '已結案',
    url: '/gifts?page=1',
    status: 'finish',
    key: 'finish'
  },
  {
    text: '已下架',
    url: '/gifts?page=1',
    status: 'pull_off',
    key: 'pulloff'
  }
  // {
  //   text: '已完成的需求贈送',
  //   url: '/needDonate?page=1',
  //   status: 'finished,thanks',
  //   key: 'needDonate'
  // }
]

export const userNeedsNavList = [
  {
    text: '進行中',
    url: '/needs',
    status: 'ongoing',
    key: 'ongoing'
  },
  {
    text: '未開始',
    url: '/needs',
    status: 'pending',
    key: 'pending'
  },
  {
    text: '已結案',
    url: '/needs',
    status: 'finish',
    key: 'finish'
  },
  {
    text: '已下架',
    url: '/needs',
    status: 'pull_off',
    key: 'pulloff'
  }
]

export const userReqGiftsNavList = [
  {
    text: '索取中',
    url: 'giftRequest',
    status: 'requesting,pass',
    key: 'ongoing'
  },
  {
    text: '已獲贈',
    url: 'giftRequest',
    status: 'remitting,remitted,received_money,sent,finished,overdue,thanks,confirm_ship',
    key: 'token'
  },
  {
    text: '未獲贈',
    url: 'giftRequest',
    status: 'cancel,not_obtained',
    key: 'cancel'
  }
]

export const userThanksNavList = [
  {
    text: '獲得的感謝',
    url: '/thanks?to_user_id=id&&parent_thanks_id=0'
  },
  {
    text: '發出的感謝',
    url: '/thanks?from_user_id=id&page=1&parent_thanks_id=0'
  }
]

export const userWishesNavList = [
  {
    text: '已認養',
    url: '/wish_donates',
    status: 'init'
  },
  {
    text: '認養已送達',
    url: '/wish_donates',
    status: 'sent'
  }
]

export const userTraceNavList = [
  {
    text: '禮物',
    url: '/',
    status: ''
  },
  {
    text: '需求',
    url: '/',
    status: ''
  },
  {
    text: '會員',
    url: '/user_marks',
    status: ''
  }
]

export const roleList = [
  {
    label: '一般會員',
    value: 'normal',
    id: 36
  },
  {
    label: '關懷會員',
    value: 'care',
    id: 31
  },
  {
    label: '公益團體',
    value: 'commonweal',
    id: 32
  },
  {
    label: '學校單位',
    value: 'school',
    id: 34
  },
  {
    label: '政府機關',
    value: 'gov',
    id: 35
  },
  {
    label: '企業行號',
    value: 'company',
    id: 33
  },
  {
    label: '官方帳號',
    value: 'official',
    id: 51
  },
  {
    label: 'GC循環站',
    value: 'gccycle',
    id: 52
  }
]

export const catHashList = [
  {
    value: '企業',
    key: 'company',
    carbonAccountFlag: true // 減碳帳號是否支持
  },
  {
    value: '學校',
    key: 'school',
    carbonAccountFlag: false // 減碳帳號是否支持
  },
  {
    value: '政府',
    key: 'gov',
    carbonAccountFlag: false // 減碳帳號是否支持
  },
  {
    value: '非營利',
    key: 'commonweal',
    carbonAccountFlag: false // 減碳帳號是否支持
  },
  {
    value: '個人',
    key: 'normal',
    carbonAccountFlag: false // 減碳帳號是否支持
  }
]

export const verifiedRoleCategories = ['commonweal', 'official', 'company', 'gov', 'school', 'gccycle']

// 運送狀態
export const stepOptions = [
  { label: '待收下', value: 'init' },
  { label: '索取中', value: 'requesting' },
  { label: '已略過 ', value: 'pass' },
  { label: '待付運費', value: 'remitting' },
  { label: '已經匯款', value: 'remitted' },
  { label: '等待寄送', value: 'received_money' },
  { label: '等待寄送', value: 'confirm_ship' },
  { label: '已寄送', value: 'sent' },
  { label: '已取消', value: 'cancel' },
  { label: '已完成', value: 'finished' },
  { label: '逾期未取', value: 'overdue' },
  { label: '已感謝', value: 'thanks' },
  { label: '未獲贈', value: 'not_obtained' },
  {
    label: '申請合併中',
    value: 'merge_requesting'
  },
  {
    label: '已同意',
    value: 'merge_allowed'
  },
  {
    label: '已拒絕',
    value: 'merge_rejected'
  }
]

// const thingCategoryIcons = {
//   '女裝、女用品': iconSidebar01,
//   '化妝品、保養品': iconSidebar21,
//   '男裝、男用品': iconSidebar02,
//   '圖書、文具、影音': iconSidebar03,
//   '婦幼、童裝、嬰幼': iconSidebar04,
//   '運動、戶外、休閒': iconSidebar05,
//   '居家、餐廚': iconSidebar06,
//   '食品、飲料': iconSidebar07,
//   '家電、視聽': iconSidebar08,
//   '手機、配件': iconSidebar09,
//   '日用、清潔': iconSidebar10,
//   '汽機車周邊': iconSidebar11,
//   '玩具、收藏': iconSidebar12,
//   '電腦、周邊': iconSidebar13,
//   '教學、人力': iconSidebar14,
//   '相機、攝影': iconSidebar15,
//   '票卷、點數': iconSidebar16,
//   '電玩相關': iconSidebar17,
//   '寵物相關': iconSidebar18,
//   '家具': iconSidebar19,
//   '其他': iconSidebar20,
//   'default': iconSidebar20
// }

// 筛选器
const filterCategory = [
  {
    icon: iconSidebar01,
    key: '1',
    label: '女裝、女用品',
    value: '女裝、女用品'
  },
  {
    icon: iconSidebar21,
    key: '49',
    label: '化妝品、保養品',
    value: '化妝品、保養品'
  },
  {
    icon: iconSidebar02,
    key: '2',
    label: '男裝、男用品',
    value: '男裝、男用品'
  },
  {
    icon: iconSidebar03,
    key: '3',
    label: '圖書、文具、影音',
    value: '圖書、文具、影音'
  },
  {
    icon: iconSidebar04,
    key: '4',
    label: '婦幼、童裝、嬰幼',
    value: '婦幼、童裝、嬰幼'
  },
  {
    icon: iconSidebar05,
    key: '5',
    label: '運動、戶外、休閒',
    value: '運動、戶外、休閒'
  },
  {
    icon: iconSidebar06,
    key: '6',
    label: '居家、餐廚',
    value: '居家、餐廚'
  },
  {
    icon: iconSidebar07,
    key: '7',
    label: '食品、飲料',
    value: '食品、飲料'
  },
  {
    icon: iconSidebar08,
    key: '8',
    label: '家電、視聽',
    value: '家電、視聽'
  },
  {
    icon: iconSidebar09,
    key: '9',
    label: '手機、配件',
    value: '手機、配件'
  },
  {
    icon: iconSidebar10,
    key: '10',
    label: '日用、清潔',
    value: '日用、清潔'
  },
  {
    icon: iconSidebar11,
    key: '11',
    label: '汽機車周邊',
    value: '汽機車周邊'
  },
  {
    icon: iconSidebar12,
    key: '12',
    label: '玩具、收藏',
    value: '玩具、收藏'
  },
  {
    icon: iconSidebar13,
    key: '13',
    label: '電腦、周邊',
    value: '電腦、周邊'
  },
  {
    icon: iconSidebar14,
    key: '14',
    label: '教學、人力',
    value: '教學、人力'
  },
  {
    icon: iconSidebar15,
    key: '15',
    label: '相機、攝影',
    value: '相機、攝影'
  },
  {
    icon: iconSidebar16,
    key: '16',
    label: '票卷、點數',
    value: '票卷、點數'
  },
  {
    icon: iconSidebar17,
    key: '17',
    label: '電玩相關',
    value: '電玩相關'
  },
  {
    icon: iconSidebar18,
    key: '18',
    label: '寵物相關',
    value: '寵物相關'
  },
  {
    icon: iconSidebar19,
    key: '19',
    label: '家具',
    value: '家具'
  },
  {
    icon: iconSidebar20,
    key: '20',
    label: '其他',
    value: '其他'
  }
]
export const filterOptionsGift = {
  isNew: [
    {
      key: 1,
      value: '全新'
    }
  ],
  ongoing: [
    {
      key: 1,
      value: '贈送中'
    }
  ],
  orgFirst: [
    {
      key: 1,
      value: '公益團體優先'
    }
  ],
  isTraceUser: [
    {
      key: 1,
      value: '我追蹤的'
    }
  ],
  shipway: [
    {
      key: 'ibox',
      value: 'ｉ郵箱'
    },
    {
      key: 'hilife',
      value: '萊爾富'
    },
    {
      key: 'seven_eleven',
      value: '7-11交貨便'
    }
  ],
  video: [
    {
      key: 1,
      value: '有影片'
    }
  ],
  sort: [
    {
      key: 'random',
      value: '亂序'
    },
    {
      key: 'trends',
      value: '熱門度'
    },
    {
      key: 'nearby',
      value: '我附近的禮物'
    },
    {
      key: '',
      value: '刊登時間：新到舊'
    },
    {
      key: 'earliest',
      value: '刊登時間：舊到新'
    }
  ]
  // category: filterCategory
}

export const filterOptionsFlash = {
  ongoing: [
    {
      key: 1,
      value: '贈送中'
    }
  ],
  video: [
    {
      key: 1,
      value: '有影片'
    }
  ],
  isNew: [
    {
      key: 1,
      value: '全新'
    }
  ],
  sort: [
    {
      key: 'random',
      value: '亂序'
    },
    {
      key: '',
      value: '刊登時間：新到舊'
    },
    {
      key: 'earliest',
      value: '刊登時間：舊到新'
    }
  ]
}

export const filterOptionsNeed = {
  userRoleType: [
    {
      key: 'commonweal,school',
      value: '公益團體/學校'
    },
    {
      key: 'care',
      value: '關懷會員'
    }
  ],
  directPurchase: [
    {
      key: 1,
      value: 'momo公益直購'
    }
  ],
  status: [
    {
      key: 'ongoing',
      value: '進行中'
    }
  ],
  isTraceUser: [
    {
      key: 1,
      value: '我追蹤的'
    }
  ],
  shipway: [
    {
      key: 'ibox',
      value: 'ｉ郵箱'
    },
    {
      key: 'hilife',
      value: '萊爾富'
    },
    {
      key: 'seven_eleven',
      value: '7-11交貨便'
    }
  ],
  needSectionType: [
    {
      key: '重建家園',
      value: '重建家園'
    }
  ],
  sort: [
    {
      key: 'nearby',
      value: '我附近的需求'
    },
    {
      key: 'earliest',
      value: '時間倒序'
    },
    {
      key: 'trends',
      value: '熱門度'
    }
  ]
}

export const thingsStatusList = [
  { label: '進行中', value: 'ongoing' },
  { label: '未開始', value: 'pending' },
  { label: '已結案', value: 'finish' },
  { label: '已下架', value: 'pull_off' }
]

export const filterOptionsLoveBox = {
  userRoleType: [
    {
      key: 'VIPONLY',
      value: '公益團體索取'
    },
    {
      key: 'NOTVIP',
      value: '一般會員索取'
    }
  ],
  ongoing: [
    {
      key: 1,
      value: '贈送中'
    }
  ],
  sort: [
    {
      key: 'upcoming_pull_off',
      value: '即將下架'
    },
    {
      key: 'trends',
      value: '熱門度'
    }
  ],
  category: filterCategory
}
// 物品價值
export const valuationList = [
  { label: '0~500元', key: 0 },
  { label: '500~1000元', key: 500 },
  { label: '1000~5000元', key: 1000 },
  { label: '5000~10000元', key: 5000 },
  { label: '10000~50000元', key: 10000 },
  { label: '50000元以上', key: 50000 }
]

export const statusMap = [
  {
    value: 0,
    text: 'requesting',
    step: 0
  },
  {
    value: 2,
    text: 'init',
    step: 0
  },
  {
    value: 4,
    text: 'pass',
    step: 0
  },
  {
    value: 8,
    text: 'remitting',
    step: 1
  },
  {
    value: 16,
    text: 'remitted',
    step: 1
  },
  {
    value: 32,
    text: 'received_money',
    step: 2
  },
  {
    value: 33,
    text: 'confirm_ship',
    step: 2
  },
  {
    value: 48,
    text: 'sent',
    step: 2
  },
  {
    value: 64,
    text: '確認收到',
    step: 3
  },
  {
    value: 80,
    text: 'cancel',
    step: 0
  },
  {
    value: 128,
    text: 'finished',
    step: 3
  },
  {
    value: 128,
    text: 'overdue',
    step: 3
  },
  {
    value: 255,
    text: 'thanks',
    step: 4
  },
  {
    value: 80,
    text: 'not_obtained',
    step: 0
  }
]

export const ShipStatus = {
  SHIP_STATUS_REQUESTING: 'requesting',
  SHIP_STATUS_MERGE_REQUESTING: 'merge_requesting',
  SHIP_STATUS_MERGE_REJECTED: 'merge_rejected',
  SHIP_STATUS_INIT: 'init',
  SHIP_STATUS_PASS: 'pass',
  SHIP_STATUS_REMITTING: 'remitting',
  SHIP_STATUS_REMITTED: 'remitted',
  SHIP_STATUS_RECEIVED_MONEY: 'received_money',
  SHIP_STATUS_CONFIRM_SHIP: 'confirm_ship', // 已確認物流
  SHIP_STATUS_SENT: 'sent', // step #48, 已寄送
  SHIP_STATUS_CANCEL: 'cancel',
  SHIP_STATUS_FINISHED: 'finished',
  SHIP_STATUS_THANKS: 'thanks',
  SHIP_STATUS_NOT_OBTAINED: 'not_obtained',
  SHIP_STATUS_OVERDUE: 'overdue' // 新增未取件的狀態
}

// 根據 statusMap 的 step而來，歷史遺留
export const ShipStatusNumber = {
  SHIP_STATUS_SEND: 7, // 確認贈送
  SHIP_STATUS_REMITTED: 16, // 確認匯款
  SHIP_STATUS_GOT_THE_FEE: 32, // 確認收款
  SHIP_STATUS_CANCEL: 80
}

// 互動卡消息類型
export const messageBusinessType = {
  MESSAGE_TYPE_NORMAL: 1,
  MESSAGE_TYPE_SYSTEM: 2,
  MESSAGE_TYPE_REQUEST_REASON: 3,
  MESSAGE_TYPE_THANKS: 4
}

export const Shipopts = {
  POD: 'pod',
  RECEIVER: 'receiver',
  SENDER: 'sender'
}

export const ShipPayMethods = {
  OFFLINE: 0, // 線下匯款
  ONLINE: 1 // 線上點數支付
}

export const WALLET_DEAL_TYPES = {
  CHARGE: 1,
  GIFT_REQUEST: 2,
  NEED_DONATE: 3,
  FESTIVAL: 5,
  LOVE_ORDER: 6,
  EXPRESS: 7,
  FREIGHT_DONATE: 8
}

export const WALLET_RECORD_TYPES = {
  CHARGE: 1,
  CONSUME: 2,
  REFUND: 3,
  REWARD: 4,
  RETURN: 5, // 退費
  EXCHANGE: 6, // 绿点兑换
  DEPOSIT_RETURN: 7 // 押金退回
}

export const PURCHASE_FROM = {
  SELF: 0,
  DIRECT_PURCHASE: 1
}

// 運送方式
export const shipMapping = {
  way: {
    palmbox: '掌櫃',
    fami: '全家店到店',
    hct: '新竹物流',
    others: '其他物流寄送',
    meet: '面交',
    homeng: '賀盟物流(大型物資)',
    ibox: 'ｉ郵箱',
    direct_purchase: 'momo配送',
    hilife: '萊爾富',
    seven_eleven: '7-11交貨便'
  },
  opts: {
    [ShipPayMethods.OFFLINE]: {
      pod: '索取者貨到付款',
      receiver: '匯運費給贈送者',
      sender: '贈送者負擔運費',
      [undefined]: '免運費'
    },
    [ShipPayMethods.ONLINE]: {
      pod: '貨到付款',
      receiver: '蘿蔔點數支付',
      sender: '贈送者負擔運費',
      [undefined]: '免運費',
      '': '蘿蔔點數支付'
    }
  },
  infos: {
    STRING_TYPES_WANTS: 'WANTS',
    STRING_NOT_PROVIDE: '(暫未提供)',
    STRING_SHOW_AFTER_SEND: '(確認贈送後顯示)',
    STRING_SHOW_AFTER_ACCEPT: '(確認收下後顯示)',
    STRING_WAIT_FOR_PROVIDE: '(廠商報價後另行提供)',
    STRING_SHOW_AFTER_TRANSFER: '(對方確認匯款後顯示)',
    STRING_SHOW_AFTER_GOT_MONEY: '(確認收款後5-10分鐘內產生單號)',
    STRING_SHOW_AFTER_CONFIRM_DETAIL: '(確認「運送細節」後顯示)',
    STRING_SHIPSN_TIPS_FOR_HCT: '(物流士上門收件前一天下午六點後產生單號)'
  }
}

export const Shipways = {
  SHIPWAY_PALMBOX: 'palmbox',
  SHIPWAY_FAMI: 'fami',
  SHIPWAY_HCT: 'hct',
  SHIPWAY_OTHERS: 'others',
  SHIPWAY_MEET: 'meet',
  SHIPWAY_HOMENG: 'homeng',
  SHIPWAY_IBOX: 'ibox',
  SHIPWAY_DIRECT_PURCHASE: 'direct_purchase',
  SHIPWAY_HILIFE: 'hilife',
  SHIPWAY_SEVEN_ELEVEN: 'seven_eleven'
}

export const SHIP_PRICES = {
  [Shipways.SHIPWAY_IBOX]: 80,
  [Shipways.SHIPWAY_HCT]: 150,
  [Shipways.SHIPWAY_FAMI]: 60,
  [Shipways.SHIPWAY_HILIFE]: 80,
  [Shipways.SHIPWAY_SEVEN_ELEVEN]: 80
}

export const SHIP_DEPOSIT = 20
export const SHIPWAY_NEED_DEPOSIT_LIST = [
  Shipways.SHIPWAY_IBOX,
  Shipways.SHIPWAY_HILIFE,
  Shipways.SHIPWAY_SEVEN_ELEVEN
]

// 支援批次列印託運單的物流方式
// 需與後端 BrandGiftController::PRINTABLE_SHIPWAYS 保持一致
export const PRINTABLE_SHIPWAYS = [
  Shipways.SHIPWAY_HILIFE,
  Shipways.SHIPWAY_SEVEN_ELEVEN
]

export const issuesAry = [
  '兒童青少年福利',
  '婦女福利',
  '老人福利',
  '身心障礙福利',
  '綜合性服務',
  '環境保護',
  '教育與科學',
  '動物保護',
  '醫療服務',
  '宗教信仰',
  '國際救援',
  '文教藝術',
  '社區規劃',
  '政府單位',
  '其他'
]

// 上新和指定赠送完成时Modal引流活动配置
export const projectInfo = {
  startTime: '2018/9/1 00:00:00',
  endTime: '2018/9/31 23:59:59',
  // link: 'http://bit.ly/2Pdb0ZV',
  link: '/sportsday',
  name: '點擊參加替選手加油活動嗎？',
  color: '#ff3067'
}

// 礼物池谁索取了礼物的排序规则
export const giveSortRules = [
  {
    rule: 'time_up',
    value: '最近索取'
  },
  {
    rule: 'time_down',
    value: '最先索取'
  },
  {
    rule: 'thanks_rate',
    value: '感謝率從高到低'
  },
  {
    rule: 'charitys',
    value: '分享數從高到低'
  }
]

export const feedBackList = [
  {
    label: '使用問題回報'
  },
  {
    label: '操作流程諮詢',
    action: 'SHOW_WELFLOW'
  },
  {
    label: '違規行為通報'
  },
  {
    label: '使用回饋建議'
  },
  {
    label: '平台合作提案'
  },
  {
    label: '其他'
  }
]

export const shipwayInfos = [
  {
    way: 'ｉ郵箱',
    key: 'ibox',
    hint: `大小儲格均一價，蘿蔔點支付運費60元，免去送拿雙方互留個資的麻煩與困擾，每件限重20公斤，請注意儲格最大尺寸：34*24*47cm。`,
    radios: [
      {
        id: 'ibox-1',
        text: '索取者(蘿蔔點數支付)',
        value: 'receiver'
      },
      {
        id: 'ibox-2',
        text: '贈送者(蘿蔔點數支付)',
        value: 'sender'
      }
    ],
    payMethod: ShipPayMethods.ONLINE
  },
  {
    way: '萊爾富',
    key: 'hilife',
    hint:
      '萊爾富寄件限制，長＋寬＋高 ≦ 105公分，單邊長度 ≦ 45公分，總重量不得超過5公斤。',
    radios: [
      {
        id: 'hilife-1',
        text: '索取者(蘿蔔點數支付)',
        value: 'receiver'
      },
      {
        id: 'hilife-2',
        text: '贈送者(蘿蔔點數支付)',
        value: 'sender'
      }
    ],
    payMethod: ShipPayMethods.ONLINE
  },
  {
    way: '7-11交貨便',
    key: 'seven_eleven',
    hint: '7-11交貨便寄件限制，長＋寬＋高 ≦ 105公分，單邊長度 ≦ 45公分，總重量不得超過5公斤。',
    radios: [
      {
        id: 'seven-1',
        text: '索取者(蘿蔔點數支付)',
        value: 'receiver'
      },
      {
        id: 'seven-2',
        text: '贈送者(蘿蔔點數支付)',
        value: 'sender'
      }
    ],
    payMethod: ShipPayMethods.ONLINE
  },
  // 全家店到店已停用，隱藏寄送選項（保留 fami mapping 以顯示既有舊資料）
  // {
  //   way: '全家店到店',
  //   key: 'fami',
  //   hint:
  //     '全家店到店寄件限制，長＋寬＋高 ≦ 105公分，單邊長度 ≦ 45公分，總重量不得超過5公斤。',
  //   radios: [
  //     {
  //       id: 'fami-0',
  //       text: '索取者(匯款給贈送者)',
  //       value: 'receiver'
  //     },
  //     {
  //       id: 'fami-1',
  //       text: '贈送者',
  //       value: 'sender'
  //     }
  //   ]
  // },
  {
    way: '新竹物流',
    key: 'hct',
    hint:
      '新竹物流單箱三邊總長度<150公分，重量<25公斤，不收低溫貨件，贈物網專享價，全台灣本島均一價150元。',
    radios: [
      {
        id: 'hct-1',
        text: '索取者(蘿蔔點數支付)',
        value: 'receiver'
      },
      {
        id: 'hct-2',
        text: '贈送者(蘿蔔點數支付)',
        value: 'sender'
      }
    ],
    payMethod: ShipPayMethods.ONLINE
  },
  {
    way: '其他物流寄送',
    key: 'others',
    hint:
      '您現在所選的並非本站串接物流，建議充份溝通運費及寄送方式，請勿超收郵資，以免產生爭議。',
    farePlaceHolder: '請輸入運費',
    radios: [
      {
        id: 'others-1',
        text: '索取者(匯款給贈送者)',
        value: 'receiver'
      },
      {
        id: 'others-2',
        text: '贈送者',
        value: 'sender'
      }
    ]
  },
  {
    way: '面交',
    key: 'meet',
    hint: '暫定面交地址',
    farePlaceHolder: '請輸入運費'
  }
  // {
  //   way: '賀盟物流(大型物資)',
  //   key: 'homeng',
  //   hint: '賀盟物流運費請參考運費價目表',
  //   farePlaceHolder: '請參考上方運費價目表',
  //   radios: [
  //     {
  //       id: 'homeng-0',
  //       text: '索取者(貨到付款)',
  //       value: 'pod'
  //     },
  //     {
  //       id: 'homeng-1',
  //       text: '贈送者',
  //       value: 'sender'
  //     }
  //   ]
  // }
]

// 需求贈送狀態
export const needDonateDealStatusMap = [
  {
    label: '贈送中',
    value: 'init'
  },
  {
    label: '已婉拒',
    value: 'pass'
  },
  {
    label: '待付運費',
    value: 'remitting'
  },
  {
    label: '已匯款',
    value: 'remitted'
  },
  {
    label: '等待寄送',
    value: 'received_money'
  },
  {
    label: '等待寄送',
    value: 'confirm_ship'
  },
  {
    label: '已寄送',
    value: 'sent'
  },
  {
    label: '取消贈送',
    value: 'cancel'
  },
  {
    label: '完成',
    value: 'finished'
  },
  {
    label: '逾期未取',
    value: 'overdue'
  },
  {
    label: '已感謝',
    value: 'thanks'
  },
  {
    label: '申請合併中',
    value: 'merge_requesting'
  },
  {
    label: '已同意',
    value: 'merge_allowed'
  },
  {
    label: '已拒絕',
    value: 'merge_rejected'
  }
]

// 年收入
export const incomesList = [
  {
    label: '請選擇',
    value: ''
  },
  {
    label: '0-30萬',
    value: '0'
  },
  {
    label: '30-60萬',
    value: '30'
  },
  {
    label: '60-100萬',
    value: '60'
  },
  {
    label: '100-200萬',
    value: '100'
  },
  {
    label: '200萬以上',
    value: '200'
  }
]

// 關心議題
export const issues = [
  {
    label: '兒童青少年福利',
    index: 0,
    id: 'issues-0'
  },
  {
    label: '婦女福利',
    index: 1,
    id: 'issues-1'
  },
  {
    label: '老人福利',
    index: 2,
    id: 'issues-2'
  },
  {
    label: '身心障礙福利',
    index: 3,
    id: 'issues-3'
  },
  {
    label: '綜合性服務',
    index: 4,
    id: 'issues-4'
  },
  {
    label: '環境保護',
    index: 5,
    id: 'issues-5'
  },
  {
    label: '教育與科學',
    index: 6,
    id: 'issues-6'
  },
  {
    label: '動物保護',
    index: 7,
    id: 'issues-7'
  },
  {
    label: '醫療服務',
    index: 8,
    id: 'issues-8'
  },
  {
    label: '宗教信仰',
    index: 9,
    id: 'issues-9'
  },
  {
    label: '國際救援',
    index: 10,
    id: 'issues-10'
  },
  {
    label: '文教藝術',
    index: 11,
    id: 'issues-11'
  },
  {
    label: '社區規劃',
    index: 12,
    id: 'issues-12'
  },
  {
    label: '其他',
    index: 13,
    id: 'issues-13'
  }
]

export const serviceArea = ['全球性', '全國性', '區域性']

export const servicePeoNum = ['1~30', '31~50', '51~100', '101~200', '201以上']

// 自評
export const assesses = [
  {
    label: '獲得內政部評鑑甲等以上公益團體',
    index: 0,
    id: 'assesses-0'
  },
  {
    label: '台灣公益團體自律聯盟會員',
    index: 1,
    id: 'assesses-1'
  },
  {
    label: '曾取得[中華社會福利聯合勸募協會]方案計畫補助之社福團體',
    index: 2,
    id: 'assesses-2'
  },
  {
    label: '曾取得主管機關勸募活動核准字號',
    index: 3,
    id: 'assesses-3'
  },
  {
    label: '其他',
    index: 4,
    id: 'assesses-4'
  }
]

// 得知GIVE-543渠道
export const howKnow = [
  {
    label: '報章雜誌',
    index: 0,
    id: 'howKnow-0'
  },
  {
    label: '廣播/電視節目',
    index: 1,
    id: 'howKnow-1'
  },
  {
    label: '網路平台(如:facebook)',
    index: 2,
    id: 'howKnow-2'
  },
  {
    label: '親友介紹',
    index: 3,
    id: 'howKnow-3'
  },
  {
    label: '其他',
    index: 4,
    id: 'howKnow-4'
  }
]

// 社会局食材捐赠
export const donateTarget = [
  {
    name: '臺北市健軍團體家庭',
    type: '身心障礙福利',
    area: '中正區',
    foodType: '熟食、食材',
    num: '7人份',
    time: '下午13點半到16點前',
    shipway: '捐贈者協助運送',
    phone: '02-2365-9037'
  },
  {
    name: '臺北市鵬程啟能中心',
    type: '身心障礙福利',
    area: '松山區',
    foodType: '熟食、食材',
    num: '70人份',
    time: '24小時都可',
    shipway: '視物資遠近',
    phone: '02-2760-6277'
  },
  {
    name: '創世基金會 萬華平安站',
    type: '綜合性服務',
    area: '萬華區',
    foodType: '熟食、食材',
    num: '70人份',
    time: `食材：週一至週五上午8時至17時(需冷藏及冷凍，需事先聯繫)
  便當及餐盒：晚餐，下午14-16時(僅接受晚餐時段。亦需事先聯繫)`,
    shipway: '視物資遠近',
    phone: '02-2336-1247'
  },
  {
    name: '友緣基金會(高風險家綜單位)',
    type: '兒童青少年福利',
    area: '士林區',
    foodType: '熟食、食材',
    num: '38人份',
    time: '早上9點至下午16點',
    shipway: '捐贈者協助運送',
    phone: '02-2837-1910'
  },
  {
    name: '財團法人基督教臺北市伯大尼兒少家園',
    type: '兒童青少年福利',
    area: '文山區',
    foodType: '食材',
    num: '50人份',
    time: '早上8點到下午17點',
    shipway: '視物資遠近',
    phone: '02-2939-6396'
  },
  {
    name: '財團法人利伯他茲教育基金會-選擇家園',
    type: '兒童青少年福利',
    area: '信義區',
    foodType: '食材',
    num: '15人份',
    time: '24小時都可',
    shipway: '視物資遠近',
    phone: '02-2634-1363'
  },
  {
    name: '財團法人利伯他茲教育基金會-曙光家園',
    type: '兒童青少年福利',
    area: '信義區',
    foodType: '食材',
    num: '8人份',
    time: '24小時都可',
    shipway: '視物資遠近',
    phone: '02-8791-7593'
  },
  {
    name: '財團法人基督教芥菜種會',
    type: '兒童青少年福利',
    area: '南港區',
    foodType: '食材',
    num: '100人份',
    time: '早上9點到下午17點',
    shipway: '視物資遠近',
    phone: '02-2597-4868'
  },
  {
    name: '財團法人天主教善牧社會福利基金會-德蓓之家',
    type: '兒童青少年福利',
    area: '信義區',
    foodType: '食材',
    num: '4人份',
    time: '早上9點至下午20點',
    shipway: '視物資遠近',
    phone: '02-2726-6617'
  },
  {
    name: '財團法人臺北市基督教勵友中心-家處',
    type: '兒童青少年福利',
    area: '中山區',
    foodType: '食材',
    num: '10人份',
    time: '早上9點至下午17點',
    shipway: '捐贈者協助運送',
    phone: '02-2595-2052'
  },
  {
    name: '內湖老人服務中心',
    type: '老人福利',
    area: '內湖區',
    foodType: '食材',
    num: '10人份',
    time: '早上9點至下午17點',
    shipway: '捐贈者協助運送',
    phone: '02-2632-5560'
  },
  {
    name: '臺北市大同發展中心',
    type: '身心障礙福利',
    area: '大同區',
    foodType: '食材',
    num: '10人份',
    time: '早上9點至下午16點',
    shipway: '視物資遠近',
    phone: '02-2598-6886'
  },
  {
    name: '臺北市東區單親家庭服務中心',
    type: '婦女福利',
    area: '松山區',
    foodType: '食材',
    num: '10人份',
    time: '週二、週四、週五、週六早上9點至下午17點；週三下午1點至晚間20點',
    shipway: '捐贈者協助運送',
    phone: '02-2768-5256'
  },
  {
    name: '台北兒童福利中心',
    type: '兒童青少年福利',
    area: '信義區',
    foodType: '食材',
    num: '30人份',
    time: '週三下午1點至晚間20點',
    shipway: '捐贈者協助運送',
    phone: '02-3765-2575'
  },
  {
    name: '台北市城中發展中心',
    type: '身心障礙福利',
    area: '中正區',
    foodType: '食材',
    num: '50人份',
    time: '週一至週五早上9點至晚間21點',
    shipway: '捐贈者協助運送',
    phone: '02-2364-3036'
  },
  {
    name: '崇愛發展中心',
    type: '身心障礙福利',
    area: '新北市中和區',
    foodType: '食材',
    num: '150人份',
    time: '早上9點至下午16點',
    shipway: '視物資遠近',
    phone: '02-2246-0820'
  }
]

export const FATHERSDAY_ENDTIME = '2018/9/1'
export const SPORTSDAY_ENDTIME = '2018/10/1' // 地板滚球国际积分赛活动
export const ANNIVERSARY_STARTTIME = '2020/02/01'
export const ANNIVERSARY_ENDTIME = '2020/02/29 23:59:59'

/* eslint-disable */
export const baseInfoDesc = {
  reviewsRate: {
    text: '頁面主人獲贈後主動回報及感謝的機率。<br/><br/>珍惜每一次表達感謝的機會，不只提高獲贈，更是創造幸運體質的秘訣！',
    label: '感謝率'
  },
  bonus: {
    text: '當年度循環分享給一般會員的物品數量，物品寄出後自動計算。',
    label: '分享'
  },
  charitys: {
    text: '當年度捐贈給公益團體或學校的物品數量，物品寄出後自動計算。',
    label: '公益'
  },
  share: {
    text: '贈送對象為一般會員，贈出物品總數',
    label: '分享'
  },
  request: {
    text: '索取對象不限，獲贈物品總數',
    label: '延用'
  },
  commonweal: {
    text: '贈送對象為公益團體或學校，贈出物品總數',
    label: '公益'
  },
  carbonReduce: {
    text: '循環分享與公益捐贈累計之減碳成果，以公斤計（公益直購不計）',
    label: '減碳'
  },
  lovebox: {
    text: '使用GC代客贈送服務，累計贈出的物品總數',
    label: '代客贈送'
  },
  lovecarbon: {
    text: '代客贈送累計之減碳成果，以公斤計',
    label: '總減碳量'
  }
}
/* eslint-enable */

export const LOVEBOX_PROVISION_STATUS = {
  STATUS_ALL: -1,
  STATUS_DELETED: 0,
  STATUS_ON_SHELVE: 1,
  STATUS_OFF_SHELVE: 2
}

export const LOVEBOX_BOX_STATUS = {
  STATUS_INIT: 0,
  STATUS_SENT: 1,
  STATUS_RECEIVED: 2
}

export const LOVE_ORDER_STATUS = {
  STATUS_INIT: 0,
  STATUS_CANCEL: -1,
  STATUS_UNPAID: 1,
  STATUS_PAID: 2,
  STATUS_SENT: 3,
  STATUS_RECEIVED: 4,
  STATUS_DONE: 5
}

export const giftContrabandList = [
  '一條根', '萬金油', '白花油', '追風油', '驅風油', '綠油精', '萬應', '美琪藥皂', '綠的肥皂', '藥皂', '雲南白藥',
  '西瓜霜', '曼秀雷敦', '面速力達姆', '樺達喉糖', '川貝枇杷膏', '京都念慈庵', '75%酒精', '95%酒精', '浣腸', '保力達 B',
  '胃散', '胃腸藥', '乾洗手', '成藥', '四物湯', '百靈油', '龍角散', '紫雲膏', '薄荷棒', '寶馬生漱口水', '虎標',
  '撒隆巴斯', '鎮痛藥膠布', '雙氧水', '善存', '優碘', '生理食鹽水', '生理食塩水', '藥水', '感冒糖漿', '表飛鳴',
  '日本AD', '普拿疼', '維骨力', '葡萄糖胺', '治痛單', '人工淚液', '耳滴劑', '口內膏', '萌髮', '落健', '痘痘藥',
  '洗眼液', '阿斯匹靈', '伏冒熱飲', '強力施美', '膚潤康', '友露安', '抗痛寧', '利薩爾', '感冒錠', '康貝特口服',
  '葉黃素', '寧適', 'chocola bb', '舒喉', '阿德比膠囊', '新寶納多', '戒煙口嚼錠', '記憶力口香糖', '退燒塞劑',
  '益生菌', 'Counterpain', 'DHEA', '痘膚潤', '威而剛', '眼藥水', '合利他命', '散瞳劑', '益可膚', '可立舒',
  '療黴舒', '妥膚淨', '優足達', '福善美', '貝樂克', '得安穩', '耐適恩', '脈優', '美爾胰', 'OK繃', '免縫膠帶',
  '透氣膠帶', '退熱貼', '紗布', '敷料', '人工皮', '藥布', '酒精棉片', '棉花棒', '生理沖洗器', '耳溫槍', '額溫槍',
  '體溫計', '體溫槍', '體脂計', '體脂機', '血糖機', '血壓計', '血壓器', '治療儀', '低週波', '醫療用口罩', '醫療口罩',
  '醫用口罩', '手術口罩', 'N95', '醫療器材', '復健用', '手杖', '拐杖', '輪椅', '助行器', '吸鼻器', '洗鼻器', '光鼻器',
  '餵藥器', '聽診器', '針筒', '助聽器', '束腹帶', '托腹帶', '護腰', '護踝', '護膝', '護肘', '導入儀', '導入管', '導入器',
  '肌內效', '冷熱敷墊', '冷熱敷袋', '熱敷袋', '冰敷袋', '藥盒', '隱形眼鏡', '隱形眼鏡盒', '日拋', '月拋', '保養液',
  '保存液', '隱形眼鏡清潔液', '隱形眼鏡藥水', '隱形眼鏡沖洗液', '去蛋白', '瞳孔放大片', '保險套', '棉條', '月亮杯',
  '假牙清潔錠', '彈性襪', '紅外線照護燈', '切藥器', '藥品切割器', '蒸氣眼罩', '環境用藥', '殺蟲劑', '殺蟲藥', '蚊香',
  '蟑螂藥', '螞蟻藥', '老鼠藥', '蟑腦丸', '一點絕', '蟑會滅', '威滅', '蟑愛呷', '蟻愛呷', '動物用藥', '蚤不到',
  '利尿通', '泌尿安', '尿益通', '處方飼料', '醫療用', '防靜脈曲張', '痘痘貼', '貼布', '貼片', '酸痛', '驗孕', '排卵',
  '私密處', '止痛', '消炎', '藥用', '感冒藥', '藥膏', '痠痛', '抗痘', '木瓜霜', '戒煙', '滅菌', '香港腳',
  '黴菌感染用', '異位性皮膚炎', '生髮', '杜蕾斯', 'Durex', '岡本', 'Okamoto', '相模', 'sagami', 'safeway',
  '丸龜製套', 'Marugame', '安視優', '博士倫', '海昌', '科萊博', '視康', '海儷恩', '庫博', '菲士康', '樂敦', '愛爾康',
  'Alcon', '愛倍潤', '視強', '配方奶', '嬰兒配方食品', '優生嬰兒奶粉', '蝶豆花', '沉香葉', '香菸', '電子菸',
  '菸草', '菸絲', '雪茄', '尼古丁', '鞭炮', '仙女棒', '過期', '盜版', '象牙', '外幣', '順天堂', '仿冒', '非正',
  'A貨', '山寨', '換膚', '除疤', '消脂', '消除水腫', '修補傷口', '減肥', '豐胸', '瘦身', '行軍散', '啤酒', '米酒',
  '藥酒', '葡萄酒', '紅酒', '白酒', '日本酒', '清酒', '伏特加', '威士忌', '麥卡倫', '高粱', '櫻花酒', '黃酒', '料理酒',
  '梅酒', '黃道益', '五塔油', '吸乳器', '擠乳器', '假牙黏著劑', '當歸', '甘草', '肉桂', '肉桂棒', '丁香', '近視眼鏡',
  '老花眼鏡', '近視蛙鏡', '近視泳鏡', '酒精', '磁力貼', '內衣', '內褲', '內衣褲', '胸罩', '奶罩', '醫療', '效期',
  '食安', '已過', '自負', '自付'
]

export const BASE_WISH_YEAR = 2016

export const PAY_TYPE = {
  CREDIT_CARD: '01', // 信用卡
  VIRTUAL_ACCOUNT: '03',
  GOOGLE_PLAY: 'googlePlay',
  APP_STORE: 'appStore',
  GREEN_POINT: 'greenpoint'
}

export const PAY_TYPE_TEXTS = {
  [PAY_TYPE.CREDIT_CARD]: '信用卡',
  [PAY_TYPE.VIRTUAL_ACCOUNT]: 'ATM 虛擬帳號',
  [PAY_TYPE.GOOGLE_PLAY]: 'Google Play',
  [PAY_TYPE.APP_STORE]: 'App Sotre',
  [PAY_TYPE.GREEN_POINT]: '環保集點綠點兌換'
}

export const PAY_STATUS = {
  CANCEL: 0,
  CHARGING: 1,
  CHARGED: 2
}

export const PAY_STATUS_TEXTS = {
  [PAY_STATUS.CANCEL]: '已過期',
  [PAY_STATUS.CHARGING]: '待付款',
  [PAY_STATUS.CHARGED]: '儲值完成'
}

export const SPONSOR_PAY_METHOD = {
  VIRTUAL_ACCOUNT: 2,
  CREDIT_CARD: 3,
  GOOGLE_PLAY: 4,
  APP_STORE: 5
}

export const SPONSOR_PATY_TEXTS = {
  [SPONSOR_PAY_METHOD.VIRTUAL_ACCOUNT]: 'ATM 虛擬帳號',
  [SPONSOR_PAY_METHOD.CREDIT_CARD]: '信用卡',
  [SPONSOR_PAY_METHOD.GOOGLE_PLAY]: 'Google Play',
  [SPONSOR_PAY_METHOD.APP_STORE]: 'App Sotre'
}

export const SPONSOR_STATUS = {
  UNPAID: 1,
  PAID: 2,
  PAY_EXPIRED: 4,
  EXPIRED: 5
}

export const SPONSOR_STATUS_TEXTS = {
  [SPONSOR_STATUS.UNPAID]: '待支付',
  [SPONSOR_STATUS.PAID]: '贊助中',
  [SPONSOR_STATUS.PAY_EXPIRED]: '逾期未支付',
  [SPONSOR_STATUS.EXPIRED]: '贊助期滿'
}

export const SPONSOR_TYPE = {
  ONCE: 0,
  INSTALLMENTS: 1,
  SUBSCRIPTION: 2
}

export const EXPRESS_STATUS = {
  INIT: 'init', // 待完善寄件信息等
  UNPAID: 'unpaid', // 待付運費
  PAID: 'paid',
  SENT: 'sent',
  DONE: 'done',
  CANCELLED: 'cancelled'
}

export const EXPRESS_STATUS_TXT = {
  [EXPRESS_STATUS.INIT]: '待填寫收件資料',
  [EXPRESS_STATUS.UNPAID]: '待付運費',
  [EXPRESS_STATUS.PAID]: '待寄出',
  [EXPRESS_STATUS.SENT]: '待收件',
  [EXPRESS_STATUS.DONE]: '已完成',
  [EXPRESS_STATUS.CANCELLED]: '已取消'
}

export const EXPRESS_STATUS_COLOR = {
  [EXPRESS_STATUS.INIT]: '#e25443',
  [EXPRESS_STATUS.UNPAID]: '#e25443',
  [EXPRESS_STATUS.PAID]: '#ffa507',
  [EXPRESS_STATUS.SENT]: '#ffa507',
  [EXPRESS_STATUS.DONE]: '#7f7f7f',
  [EXPRESS_STATUS.CANCELLED]: '#7f7f7f'
}

export const GIFT_TYPE = {
  ALL: 0,
  NORMAL: 1,
  BOX: 2, // 名櫃好禮
  FLASH: 3, // 閃送區
  DORM: 4, // 宿舍專區
  BRAND: 5 // 品牌閃送區
}
export const WISH_TYPE = {
  WISH: 0,
  READING: 1
}

export const COUPON_RECORD_STATUS = {
  VALID: 0,
  USED: 1,
  EXPIRED: 2,
  FROZEN: 3
}

export const COUPON_TYPE = {
  NO_THRESHOLD: 0,
  DISCOUNT: 1
}

export const WISH_ORGANIZER = {
  KUENTAI: 1,
  VIS: 2,
  WPG: 3,
  MAKALOT: 4,
  MEDIATEK: 5
}

export const DONATE_TYPE = {
  GIFT: 0,
  CARD: 1
}

export const COUPON_SCENE = {
  ALL: 0, // 通用場景
  FLASH: 1, // 閃送區專用
  LOVEBOX: 2 // GC代贈索取
}

export const EARTH_DAY_BEGIN_AT = '2022/04/22 00:00:00'
export const EARTH_DAY_END_AT = '2022/05/20 23:59:59'

export const USER_STATUS = {
  NORMAL: 0,
  DEACTIVATING: 1,
  DEACTIVATED: 2,
  INACTIVE: 3
}

export const CARBON_LABELLING_USER_STATUS = {
  PENDING: 0,
  JOINED: 1,
  REJECTED: 2
}

/** 系統通知 business_type：碳標籤（含團隊公告等） */
export const MESSAGE_BUSINESS_TYPE_CARBON_LABELLING = 'carbon_labelling'

/** 與後端約定之 content 枚舉 */
export const MESSAGE_CONTENT_CARBON_LABELLING_ANNOUNCEMENT = 'CARBON_LABELLING_ANNOUNCEMENT'

export const blues = [
  '#284B8D', '#3D69AA', '#658FC9', '#89B3E3', '#B4D5F6', '#D9EBFA'
]

export const yellows = [
  '#F4AD21', '#F5BE13', '#F9D34C', '#FCE170', '#FEEEA0', '#FEF7CF'
]

export const regMobileDevice = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
